import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AddressDto} from '@sportngin/se-commerce-sdk';
import {Observable} from 'rxjs';
import {ApiModule} from '../api.module';
import {CommerceApiService} from './commerce-api.service';
import {Store} from '@ngrx/store';

@Injectable({
  providedIn: ApiModule,
})
export class CommerceAddressService extends CommerceApiService {
  readonly controllerPath: string = 'v3/commerce/shopper/address';

  constructor(
    protected http: HttpClient,
    protected store: Store,
  ) {
    super(http, store);
  }

  attachAddressToCart(guestKey: string, address: AddressDto): Observable<void> {
    const url = super.getUrl('finance/cart/attach_address');

    // The Clare API expects guest_key in the body
    return this.POST<void>(
      url,
      {
        guest_key: guestKey,
        ...address,
      },
      this.getOptions({withCredentials: true}),
    );
  }

  getUrl(path = ''): string {
    path = `${this.controllerPath}${path}`;
    return super.getUrl(path);
  }
}
